module.exports = __webpack_public_path__ + "img/insights-full.26cd043c.png";